import { render, staticRenderFns } from "./self-promotion.vue?vue&type=template&id=57cbf970&scoped=true&"
import script from "./self-promotion.vue?vue&type=script&lang=ts&"
export * from "./self-promotion.vue?vue&type=script&lang=ts&"
import style0 from "./self-promotion.vue?vue&type=style&index=0&id=57cbf970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cbf970",
  null
  
)

export default component.exports